export default ["pdf", "txt", "application/pdf", "text/plain"];
